{
    "MakeCallTitle": "Fazer ligação",
    "MakeCallTooltip": "Faça uma chamada para o dispositivo correspondente.",
    "IttTitle": "Transferência de consulta",
    "IttTooltip": "Faça uma chamada de consulta de consulta para o dispositivo correspondente para iniciar uma operação de transferência de chamada.",
    "CallDetailsTitle": "Detalhes da chamada...",
    "CallDetailsTooltip": "Exiba informações detalhadas da chamada em uma nova janela.",
    "CompleteTransferTitle": "Transferência completa",
    "CompleteTransferTooltip": "Conclua a operação de transferência de chamada de consulta iniciada anteriormente movendo a chamada em espera para o destino de destino chamado anteriormente.",
    "PickupThisCallTitle": "Atender esta chamada",
    "PickupThisCallTooltip": "Atendeu esta chamada de alerta imediatamente em seu próprio ramal.",
    "StealThisCallTitle": "Roubar esta chamada",
    "StealThisCallTooltip": "Mova a chamada atualmente atendida ou em alerta para o seu ramal, onde ela tocará posteriormente.",
    "SendToCallTitle": "Enviar chamada para...",
    "SendToCallTooltip": "Mova a chamada atualmente atendida ou em alerta para um novo destino específico onde ela tocará posteriormente.",
    "MonitorTitle": "Monitor",
    "MonitorTooltip": "Opções de dispositivo e monitor de chamadas.",
    "SilentMonitorTitle": "Monitor Silencioso",
    "SilentMonitorTooltip": "Inicie uma sessão de monitor silenciosa com a chamada atualmente atendida no dispositivo.",
    "ForcedIntrudeTitle": "Intrusão Forçada",
    "ForcedIntrudeTooltip": "Invadir (interromper) a chamada atualmente atendida no dispositivo correspondente, para que você possa participar ativamente dessa chamada.",
    "RecordCallTitle": "Gravar chamada",
    "RecordCallTooltip": "Execute uma operação de gravação de chamadas ao vivo na chamada atendida no momento no dispositivo.",
    "RegisterCallbackTitle": "Registrar retorno de chamada",
    "RegisterCallbackTooltip": "Exiba uma mensagem no dispositivo correspondente, lembrando-os de ligar de volta para seu ramal específico.",
    "AgentSignInOutTitle": "Entrada\/saída do agente",
    "AgentSignInOutTooltip": "Entrar\/sair do ramal.",
    "SignInTitle": "Entrar...",
    "SignInTitleAllGroups": "Entrar (todos os grupos)",
    "SignInTooltip": "Conecte o dispositivo ou agente correspondente, tornando-o 'de serviço' e potencialmente disponível para atender chamadas ACD.",
    "SignOutTitle": "Sair",
    "SignOutTitleAllGroups": "Sair (todos os grupos)",
    "SignOutTooltip": "Desconecte o dispositivo ou agente correspondente, tornando-os 'fora de serviço' e indisponíveis para atender chamadas ACD.",
    "GroupsTitle": "Grupos",
    "GroupsTooltip": "Escolha em quais grupos de ACDs este agente está conectado.",
    "NoGroupsTooltip": "Nenhum Grupo ACD foi encontrado para este Agente.",
    "GroupsAllTitle": "[All]",
    "SetDndOnTitle": "Ativar DND",
    "SetDndOnTooltip": "Ative o não perturbe no dispositivo, o que o tornará indisponível para receber chamadas.",
    "SetDndOffTitle": "Desligar DND",
    "SetDndOffTooltip": "Desative o não perturbe no dispositivo, o que o tornará disponível para receber chamadas de entrada.",
    "SetStatusTitle": "Definir status",
    "SetStatusTooltip": "Defina o status de ACD para este agente.",
    "AvailableTitle": "Disponível",
    "AvailableTooltip": "Defina o agente para o estado Disponível, que o tornará disponível para atender chamadas ACD.",
    "DndTitle": "ND",
    "DndTooltip": "Defina o agente para o estado DND, o que o tornará indisponível para atender chamadas ACD.",
    "WrapUpTitle": "Embrulhar",
    "WrapUpTooltip": "Defina o agente no estado de Finalização, o que o tornará indisponível para atender chamadas ACD.",
    "NotAvailableTitle": "Não disponível",
    "NotAvailableTooltip": "Defina o agente no estado ACD Indisponível e especifique adicionalmente um código de motivo, que pode ser usado para identificar por que o agente correspondente está especificamente indisponível para atender chamadas ACD.",
    "NoReasonTitle": "[Sem motivo]",
    "NoReasonTooltip": "Defina o agente no estado ACD Não Disponível sem fornecer motivo.",
    "AdvancedTooltip": "Ações avançadas de controle de chamadas.",
    "AnswerCallTitle": "Atender chamada",
    "AnswerCallTooltip": "Atenda a chamada em alerta no momento.",
    "ClearCallTitle": "Limpar chamada",
    "ClearCallTooltip": "Encerre a chamada correspondente.",
    "AdminOnlyTitle": "Somente administrador",
    "AdminOnlyTooltip": "Ações somente do administrador.",
    "DeletePhantomTitle": "Excluir chamada fantasma",
    "DeletePhantomTooltip": "Força o aplicativo a parar de modelar a chamada correspondente como ativa, o que pode afetar negativamente as estatísticas da chamada.",
    "RowOptions_AdvancedTitle": "Avançado",
    "NAME": "RowOptions",
    "SetAccountCodeMenuOptionTitle": "Definir código de conta",
    "SetAccountCodeMenuOptionTooltip": "Definir o código de conta para esta chamada.",
    "NoAccountCodeMenuOptionTitle": "[Sem código de conta].",
    "NoAccountCodeMenuOptionTooltip": "Anular o código de conta",
    "AccountCodeMenuOptionTooltip": "Definir o código de conta \"{}\" para a chamada."
}